// PhonicsLt16.js
// 包装组件：Letter Teams L16
// 路由：/phonics/lt16
import React from 'react';
import PhonicsLt from './phonics/PhonicsLt';
import { letterDataLt16 } from './phonics/phonics_data_lt16';

function PhonicsLt16() {
  return <PhonicsLt letterData={letterDataLt16} />;
}

export default PhonicsLt16;
